export function UploadProgress({ percent }) {
  if (percent == null) return null;
  return (
    <div className="mt-3" data-testid="upload-progress">
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-muted">
        <div className="h-full rounded-full bg-primary transition-[width] duration-150" style={{ width: `${percent}%` }} />
      </div>
      <p className="mt-1 text-xs text-muted-foreground">{percent < 100 ? `Uploading… ${percent}%` : "Finishing up…"}</p>
    </div>
  );
}
